import { Link } from 'react-router-dom';
import footerLogo from '../assets/FooterLogo.png';

export function Footer() {
  return (
    <footer className="bg-neutral-100 border-t border-gray-200">
      <div className="max-w-[1280px] mx-auto px-5 md:px-10 lg:px-20 py-12 md:py-16">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8">
          {/* Left side: Logo, Copyright, and Rights */}
          <div className="flex items-start gap-6 md:gap-8">
            <div className="h-16 w-16 md:h-20 md:w-20 flex-shrink-0">
              <img src={footerLogo} alt="MissionCTRL logo" className="h-full w-full object-contain" />
            </div>
            <div className="flex flex-col gap-1 text-xs md:text-sm text-gray-600">
              <div className="flex items-center gap-2">
                <span>© MissionCTRL</span>
                <span>2025</span>
              </div>
              <div>All Rights Reserved</div>
            </div>
          </div>

          {/* Right side: Links */}
          <div className="flex flex-col gap-3 text-xs md:text-sm">
            <a 
              href="mailto:support@msnctrl.ai" 
              className="text-gray-600 hover:text-gray-900 transition-colors"
            >
              support@mscontrol.ai
            </a>
            <Link 
              to="/privacy-policy" 
              className="text-gray-600 hover:text-gray-900 transition-colors"
            >
              Privacy Policy
            </Link>
            <Link 
              to="/terms-and-conditions" 
              className="text-gray-600 hover:text-gray-900 transition-colors"
            >
              Terms and Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

